import React, { useState, useRef } from 'react';
import Modal from 'react-modal';
import AddNewDoc from '../../../../../assets/images/commonIcons/AddFolder.svg';
import closePopup from '../../../../../assets/images/commonIcons/popupClose.svg';
import DocumentText from '../../../../../assets/images/commonIcons/DocumentText.svg';
import CloudUpload from '../../../../../assets/images/commonIcons/CloudUpload.svg';

export const AddDocumentFinancial = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileError, setFileError] = useState('');
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const fileInputRef = useRef(null);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    handleCancel();
  };

  const NewFinancialStatement = () => {
    openModal();
  };

  const handleFileChange = (file) => {
    const allowedFormats = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'video/hevc'];
    if (file && !allowedFormats.includes(file.type)) {
      setFileError('Supported formats: PDF, JPG, JPEG, PNG, HEVC');
      setSelectedFile(null);
      setIsFileSelected(false);
    } else {
      setFileError(''); 
      setSelectedFile(file);
      setIsFileSelected(true);
    }
  };

  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  const SubmitFinancialDocument = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.forEach((value, key) => {
    });

    closeModal();
  };

  const handleCancel = () => {
    setSelectedFile(null);
    setIsFileSelected(false);
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    const file = event.dataTransfer.files[0];
    handleFileChange(file);
  };

  return (
    <>
      <div className="col-span-1 border-2 border-[#9FA4A4] border-dashed rounded-lg my-2">
        <button className="h-full w-full" onClick={NewFinancialStatement}>
          <div className="h-full flex items-center justify-start sm:justify-center">
            <div className='flex items-center sm:block'>
              <img src={AddNewDoc} alt="AddNewDocs" className="sm:mx-auto" />
              <p>Add New Document</p>
            </div>
          </div>
        </button>
      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Upload Delete Confirmation"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="w-[260px] sm:w-[500px] md:w-[712px]">
          <div className="flex justify-between items-center min-w-[230px]">
            <h3 className="text-f18 text-[#012234] font-semibold">Upload Document</h3>
            <button className="" onClick={closeModal}>
              <img src={closePopup} alt="cancel" />
            </button>
          </div>

          <div className="">
            <form onSubmit={SubmitFinancialDocument}>
              <div className="py-2">
                <label className="block mb-1.5 text-f14px text-[#012234] font-semibold text-left" htmlFor="document_name">
                  Docuemnt Names
                </label>
                <div className="relative flex items-center rounded-md border border-[#9FA4A4]">
                  <img src={DocumentText} alt="documentText" className="px-1" />
                  <input type="text" name="text" required className="w-full h-10 rounded-md" />
                </div>
              </div>

              <div className="py-2">
                <label className="block mb-1.5 text-f14px text-[#012234] font-semibold text-left" htmlFor="document_name">
                   Upload Audited Financial Statements
                </label>

                <div
                  className={`relative flex items-center justify-center rounded-md border border-[#9FA4A4] border-dashed w-full min-h-[150px] hover:cursor-pointer ${selectedFile ? 'hidden' : ''} ${isDragging ? 'border-blue-500' : ''}`}
                  onClick={handleChooseFile}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <div className="max-w-[400px] my-6">
                    <div>
                      <img src={CloudUpload} alt="cloudUpload" className="mx-auto w-[50px]" />
                    </div>
                    <div className="text-center py-4">
                      <p className="py-2">Drag &amp; drop or <span>Choose file</span> to upload</p>
                      <p className="text-secondary">Supported format: PDF, JPG, JPEG, PNG, HEVC</p>
                      <p className="text-secondary">(should be less than 3 MB)</p>
                    </div>
                  </div>
                </div>

                {isFileSelected && (
                  <div className="relative flex items-center rounded-md border border-[#9FA4A4] border-dashed w-full">
                    <div className="py-4 px-2">
                      <p>{selectedFile.name}</p>
                    </div>
                    <button className="absolute top-[2%] right-[2%] text-f12 font-bold" onClick={handleCancel}>
                      &#9587;
                    </button>
                  </div>
                )}

                {fileError && (
                  <p className="text-red-500 mt-2 text-sm">{fileError}</p>
                )}
              </div>

              <input type="file" ref={fileInputRef} onChange={(event) => handleFileChange(event.target.files[0])} className="hidden" accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.csv,.xlsx" />

              <button type="submit" className="mt-4 bg-blue-500 hover:bg-blue-700 font-bold py-2 px-4 w-full bg-[#FB512D] text-white rounded">Save Changes</button>

            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};
